import { useMemo } from 'react';
import { UserProfileResource } from 'util/resources/UserProfile';
import { ContactCard } from 'features/ContactCard/ContactCard';
import { CardWrapperProps } from 'features/ContactCard/CardWrappers/CardWrapper.types';

export const UserProfileCard = (props: CardWrapperProps) => {
  const { conversation, lastJobApplication, active = false, onClick, metadata } = props;

  const conversationPrimitive = JSON.stringify(conversation.attributes());

  const userProfile = conversation
    .conversationMembers()
    .toArray()
    .find((member) => member.messageableType === 'UserProfile')
    .messageable?.() as UserProfileResource;

  const [userName, userAvatarSrc] = useMemo(() => {
    if (!userProfile) {
      return ['Unknown', undefined];
    }

    return [userProfile.fullName(), userProfile.avatar?.smallUrl];
  }, [conversationPrimitive]);

  if (!userProfile) {
    return null;
  }

  return (
    <ContactCard
      name={userName}
      contactAvatarSrc={userAvatarSrc}
      contactType="UserProfile"
      conversation={conversation}
      active={active}
      onClick={onClick}
      lastJobApplication={lastJobApplication}
      metadata={metadata}
    />
  );
};

UserProfileCard.displayName = 'UserProfileCard';
